import { SurahsType } from "../types";
const surahs: Array<SurahsType> = [
  {
    number: 1,
    nameEnglish: "Al-Fatiha",
    translation: "The Opening",
    nameArabic: "سُوْرَةُ الْفَاتِحَةِ",
    totalAyahs: 7,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 5,
    juzzNumber: [1],
  },
  {
    number: 2,
    nameEnglish: "Al-Baqarah",
    translation: "The Cow",
    nameArabic: "سُوْرَةُ البَقَرَةِ",
    totalAyahs: 286,
    revelation: "Madani",
    revelationArabic: "مدنية",
    revelationOrder: 87,
    juzzNumber: [1, 2],
  },
  {
    number: 3,
    nameEnglish: "Al-Imran",
    translation: "The Family of Imraan",
    nameArabic: "سُوْرَةُ اٰلِ عِمْرٰنَ",
    totalAyahs: 200,
    revelation: "Madani",
    revelationArabic: "مدنية",
    revelationOrder: 89,
    juzzNumber: [3],
  },
  {
    number: 4,
    nameEnglish: "An-Nisa",
    translation: "The Women",
    nameArabic: "سُوْرَةُ النِّسَآءِ",
    totalAyahs: 176,
    revelation: "Madani",
    revelationArabic: "مدنية",
    revelationOrder: 92,
    juzzNumber: [4, 5],
  },
  {
    number: 5,
    nameEnglish: "Al-Maidah",
    translation: "The Table",
    nameArabic: "سُوْرَةُ المَآئِدَةِ",
    totalAyahs: 120,
    revelation: "Madani",
    revelationArabic: "مدنية",
    revelationOrder: 112,
    juzzNumber: [6],
  },
  {
    number: 6,
    nameEnglish: "Al-An'aam",
    translation: "The Cattle",
    nameArabic: "سُوْرَةُ الْاَنْعَامِ",
    totalAyahs: 165,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 55,
    juzzNumber: [7],
  },
  {
    number: 7,
    nameEnglish: "Al-A'raaf",
    translation: "The Heights",
    nameArabic: "سُوْرَةُ الْاَعْرَافِ",
    totalAyahs: 206,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 39,
    juzzNumber: [8],
  },
  {
    number: 8,
    nameEnglish: "Al-Anfaal",
    translation: "The Spoils of War",
    nameArabic: "سُوْرَةُ الْاَنْفَالِ",
    totalAyahs: 75,
    revelation: "Madani",
    revelationArabic: "مدنية",
    revelationOrder: 88,
    juzzNumber: [9],
  },
  {
    number: 9,
    nameEnglish: "At-Tawbah",
    translation: "The Repentance",
    nameArabic: "سُوْرَةُ التَّوْبَةِ",
    totalAyahs: 129,
    revelation: "Madani",
    revelationArabic: "مدنية",
    revelationOrder: 113,
    juzzNumber: [10],
  },
  {
    number: 10,
    nameEnglish: "Yunus",
    translation: "Jonas",
    nameArabic: "سُوْرَةُ يُوْنُسَ",
    totalAyahs: 109,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 51,
    juzzNumber: [11],
  },
  {
    number: 11,
    nameEnglish: "Hud",
    translation: "Hud",
    nameArabic: "سُوْرَةُ هُوْدٍ",
    totalAyahs: 123,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 52,
    juzzNumber: [11],
  },
  {
    number: 12,
    nameEnglish: "Yusuf",
    translation: "Joseph",
    nameArabic: "سُوْرَةُ يُوسُفَ",
    totalAyahs: 111,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 53,
    juzzNumber: [12],
  },
  {
    number: 13,
    nameEnglish: "Ar-Rad",
    translation: "The Thunder",
    nameArabic: "سُوْرَةُ الرَّعْدِ",
    totalAyahs: 43,
    revelation: "Madani",
    revelationArabic: "مدنية",
    revelationOrder: 96,
    juzzNumber: [13],
  },
  {
    number: 14,
    nameEnglish: "Ibrahim",
    translation: "Abraham",
    nameArabic: "سُوْرَةُ اِبْرَاهِيْمَ",
    totalAyahs: 52,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 72,
    juzzNumber: [13],
  },
  {
    number: 15,
    nameEnglish: "Al-Hijr",
    translation: "The Rock",
    nameArabic: "سُوْرَةُ الْحِجْرِ",
    totalAyahs: 99,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 54,
    juzzNumber: [14],
  },
  {
    number: 16,
    nameEnglish: "An-Nahl",
    translation: "The Bee",
    nameArabic: "سُوْرَةُ النَّحْلِ",
    totalAyahs: 128,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 70,
    juzzNumber: [14],
  },
  {
    number: 17,
    nameEnglish: "Al-Isra",
    translation: "The Night Journey",
    nameArabic: "سُوْرَةُ الإِسۡرَاءِ",
    totalAyahs: 111,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 50,
    juzzNumber: [15],
  },
  {
    number: 18,
    nameEnglish: "Al-Kahf",
    translation: "The Cave",
    nameArabic: "سُوْرَةُ الْكَهْفِ",
    totalAyahs: 110,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 69,
    juzzNumber: [15],
  },
  {
    number: 19,
    nameEnglish: "Maryam",
    translation: "Mary",
    nameArabic: "سُوْرَةُ مَرْيَمَ",
    totalAyahs: 98,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 44,
    juzzNumber: [16],
  },
  {
    number: 20,
    nameEnglish: "Taha",
    translation: "Taa-Haa",
    nameArabic: "سُوْرَةُ طٰهٰ",
    totalAyahs: 135,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 45,
    juzzNumber: [16],
  },
  {
    number: 21,
    nameEnglish: "Al-Anbiya",
    translation: "The Prophets",
    nameArabic: "سُوْرَةُ الْاَنْۣبِيَآءِ",
    totalAyahs: 112,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 73,
    juzzNumber: [17],
  },
  {
    number: 22,
    nameEnglish: "Al-Hajj",
    translation: "The Pilgrimage",
    nameArabic: "سُوْرَةُ الْحَجِّ",
    totalAyahs: 78,
    revelation: "Madani",
    revelationArabic: "مدنية",
    revelationOrder: 103,
    juzzNumber: [17],
  },
  {
    number: 23,
    nameEnglish: "Al-Muminun",
    translation: "The Believers",
    nameArabic: "سُوْرَةُ الْمُؤْمِنُوْنَ",
    totalAyahs: 118,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 74,
    juzzNumber: [18],
  },
  {
    number: 24,
    nameEnglish: "An-Nur",
    translation: "The Light",
    nameArabic: "سُوْرَةُ النُّوْرِ",
    totalAyahs: 64,
    revelation: "Madani",
    revelationArabic: "مدنية",
    revelationOrder: 102,
    juzzNumber: [18],
  },
  {
    number: 25,
    nameEnglish: "Al-Furqan",
    translation: "The Criterion",
    nameArabic: "سُوْرَةُ الْفُرْقَانِ",
    totalAyahs: 77,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 42,
    juzzNumber: [19],
  },
  {
    number: 26,
    nameEnglish: "Ash-Shuara",
    translation: "The Poets",
    nameArabic: "سُوْرَةُ الشُّعَرَآءِ",
    totalAyahs: 227,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 47,
    juzzNumber: [19],
  },
  {
    number: 27,
    nameEnglish: "An-Naml",
    translation: "The Ant",
    nameArabic: "سُوْرَةُ النَّمْلِ",
    totalAyahs: 93,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 48,
    juzzNumber: [20],
  },
  {
    number: 28,
    nameEnglish: "Al-Qasas",
    translation: "The Stories",
    nameArabic: "سُوْرَةُ الْقَصَصِ",
    totalAyahs: 88,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 49,
    juzzNumber: [20],
  },
  {
    number: 29,
    nameEnglish: "Al-Ankabut",
    translation: "The Spider",
    nameArabic: "سُوْرَةُ الْعَنْكَبُوْتِ",
    totalAyahs: 69,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 85,
    juzzNumber: [21],
  },
  {
    number: 30,
    nameEnglish: "Ar-Rum",
    translation: "The Romans",
    nameArabic: "سُوْرَةُ الرُّوْمِ",
    totalAyahs: 60,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 84,
    juzzNumber: [21],
  },
  {
    number: 31,
    nameEnglish: "Luqman",
    translation: "Luqman",
    nameArabic: "سُوْرَةُ لُقْمَانَ",
    totalAyahs: 34,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 57,
    juzzNumber: [21],
  },
  {
    number: 32,
    nameEnglish: "As-Sajda",
    translation: "The Prostration",
    nameArabic: "سُوْرَةُ السَّجْدَةِ",
    totalAyahs: 30,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 75,
    juzzNumber: [21],
  },
  {
    number: 33,
    nameEnglish: "Al-Ahzab",
    translation: "The Clans",
    nameArabic: "سُوْرَةُ الْاَحْزَابِ",
    totalAyahs: 73,
    revelation: "Madani",
    revelationArabic: "مدنية",
    revelationOrder: 90,
    juzzNumber: [22],
  },
  {
    number: 34,
    nameEnglish: "Saba",
    translation: "Sheba",
    nameArabic: "سُوْرَةُ سَبَاٍ",
    totalAyahs: 54,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 58,
    juzzNumber: [22],
  },
  {
    number: 35,
    nameEnglish: "Fatir",
    translation: "The Originator",
    nameArabic: "سُوْرَةُ فَاطِرٍ",
    totalAyahs: 45,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 43,
    juzzNumber: [22],
  },
  {
    number: 36,
    nameEnglish: "Ya-Sin",
    translation: "Yaseen",
    nameArabic: "سُوْرَةُ يٰسٓ",
    totalAyahs: 83,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 41,
    juzzNumber: [23],
  },
  {
    number: 37,
    nameEnglish: "As-Saffat",
    translation: "Those drawn up in Ranks",
    nameArabic: "سُوْرَةُ الصَّافَّاتِ",
    totalAyahs: 182,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 56,
    juzzNumber: [23],
  },
  {
    number: 38,
    nameEnglish: "Sad",
    translation: "The letter Saad",
    nameArabic: "سُوْرَةُ صٓ",
    totalAyahs: 88,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 38,
    juzzNumber: [23],
  },
  {
    number: 39,
    nameEnglish: "Az-Zumar",
    translation: "The Groups",
    nameArabic: "سُوْرَةُ الزُّمَرِ",
    totalAyahs: 75,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 59,
    juzzNumber: [24],
  },
  {
    number: 40,
    nameEnglish: "Ghafir",
    translation: "The Forgiver",
    nameArabic: "سُوْرَةُ غافر ",
    totalAyahs: 85,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 60,
    juzzNumber: [24],
  },
  {
    number: 41,
    nameEnglish: "Fussilat",
    translation: "Explained in detail",
    nameArabic: "سُوْرَةُ فُصِّلَتۡ",
    totalAyahs: 54,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 61,
    juzzNumber: [24],
  },
  {
    number: 42,
    nameEnglish: "Ash-Shura",
    translation: "Consultation",
    nameArabic: "سُوْرَةُ الشُّوْرٰي",
    totalAyahs: 53,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 62,
    juzzNumber: [25],
  },
  {
    number: 43,
    nameEnglish: "Az-Zukhruf",
    translation: "Ornaments of gold",
    nameArabic: "سُوْرَةُ الزُّخْرُفِ",
    totalAyahs: 89,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 63,
    juzzNumber: [25],
  },
  {
    number: 44,
    nameEnglish: "Ad-Dukhan",
    translation: "The Smoke",
    nameArabic: "سُوْرَةُ الدُّخَانِ",
    totalAyahs: 59,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 64,
    juzzNumber: [25],
  },
  {
    number: 45,
    nameEnglish: "Al-Jathiya",
    translation: "Crouching",
    nameArabic: "سُوْرَةُ الْجَاثِيَةِ",
    totalAyahs: 37,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 65,
    juzzNumber: [25],
  },
  {
    number: 46,
    nameEnglish: "Al-Ahqaf",
    translation: "The Dunes",
    nameArabic: "سُوْرَةُ الْاَحْقَافِ",
    totalAyahs: 35,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 66,
    juzzNumber: [26],
  },
  {
    number: 47,
    nameEnglish: "Muhammad",
    translation: "Muhammad",
    nameArabic: "سُوْرَةُ مُحَمَّدٍ",
    totalAyahs: 38,
    revelation: "Madani",
    revelationArabic: "مدنية",
    revelationOrder: 95,
    juzzNumber: [26],
  },
  {
    number: 48,
    nameEnglish: "Al-Fath",
    translation: "The Victory",
    nameArabic: "سُوْرَةُ الْفَتْحِ",
    totalAyahs: 29,
    revelation: "Madani",
    revelationArabic: "مدنية",
    revelationOrder: 111,
    juzzNumber: [26],
  },
  {
    number: 49,
    nameEnglish: "Al-Hujurat",
    translation: "The Inner Apartments",
    nameArabic: "سُوْرَةُ الْحُجُراتِ",
    totalAyahs: 18,
    revelation: "Madani",
    revelationArabic: "مدنية",
    revelationOrder: 106,
    juzzNumber: [26],
  },
  {
    number: 50,
    nameEnglish: "Qaf",
    translation: "The letter Qaaf",
    nameArabic: "سُوْرَةُ قٓ",
    totalAyahs: 45,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 34,
    juzzNumber: [26],
  },
  {
    number: 51,
    nameEnglish: "Adh-Dhariyat",
    translation: "The Winnowing Winds",
    nameArabic: "سُوْرَةُ الذَّارِياتِ",
    totalAyahs: 60,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 67,
    juzzNumber: [27],
  },
  {
    number: 52,
    nameEnglish: "At-Tur",
    translation: "The Mount",
    nameArabic: "سُوْرَةُ الطُّوْرِ",
    totalAyahs: 49,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 76,
    juzzNumber: [27],
  },
  {
    number: 53,
    nameEnglish: "An-Najm",
    translation: "The Star",
    nameArabic: "سُوْرَةُ النَّجْمِ",
    totalAyahs: 62,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 23,
    juzzNumber: [27],
  },
  {
    number: 54,
    nameEnglish: "Al-Qamar",
    translation: "The Moon",
    nameArabic: "سُوْرَةُ الْقَمَرِ",
    totalAyahs: 55,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 37,
    juzzNumber: [27],
  },
  {
    number: 55,
    nameEnglish: "Ar-Rahman",
    translation: "The Beneficent",
    nameArabic: "سُوْرَةُ الرَّحْمٰنِ",
    totalAyahs: 78,
    revelation: "Madani",
    revelationArabic: "مدنية",
    revelationOrder: 97,
    juzzNumber: [27],
  },
  {
    number: 56,
    nameEnglish: "Al-Waqia",
    translation: "The Inevitable",
    nameArabic: "سُوْرَةُ الْوَاقِعَةِ",
    totalAyahs: 96,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 46,
    juzzNumber: [27],
  },
  {
    number: 57,
    nameEnglish: "Al-Hadid",
    translation: "The Iron",
    nameArabic: "سُوْرَةُ الْحَدِيْدِ",
    totalAyahs: 29,
    revelation: "Madani",
    revelationArabic: "مدنية",
    revelationOrder: 94,
    juzzNumber: [27],
  },
  {
    number: 58,
    nameEnglish: "Al-Mujadila",
    translation: "The Pleading Woman",
    nameArabic: "سُوْرَةُ الْمُجَادَلَةِ",
    totalAyahs: 22,
    revelation: "Madani",
    revelationArabic: "مدنية",
    revelationOrder: 105,
    juzzNumber: [28],
  },
  {
    number: 59,
    nameEnglish: "Al-Hashr",
    translation: "The Exile",
    nameArabic: "سُوْرَةُ الْحَشْرِ",
    totalAyahs: 24,
    revelation: "Madani",
    revelationArabic: "مدنية",
    revelationOrder: 101,
    juzzNumber: [28],
  },
  {
    number: 60,
    nameEnglish: "Al-Mumtahina",
    translation: "She that is to be examined",
    nameArabic: "سُوْرَةُ الْمُمْتَحِنَةِ",
    totalAyahs: 13,
    revelation: "Madani",
    revelationArabic: "مدنية",
    revelationOrder: 91,
    juzzNumber: [28],
  },
  {
    number: 61,
    nameEnglish: "As-Saff",
    translation: "The Ranks",
    nameArabic: "سُوْرَةُ الصَّفِّ",
    totalAyahs: 14,
    revelation: "Madani",
    revelationArabic: "مدنية",
    revelationOrder: 109,
    juzzNumber: [28],
  },
  {
    number: 62,
    nameEnglish: "Al-Jumuah",
    translation: "Friday",
    nameArabic: "سُوْرَةُ الْجُمُعَةِ",
    totalAyahs: 11,
    revelation: "Madani",
    revelationArabic: "مدنية",
    revelationOrder: 110,
    juzzNumber: [28],
  },
  {
    number: 63,
    nameEnglish: "Al-Munafiqun",
    translation: "The Hypocrites",
    nameArabic: "سُوْرَةُ الْمُنَافِقُوْنَ",
    totalAyahs: 11,
    revelation: "Madani",
    revelationArabic: "مدنية",
    revelationOrder: 104,
    juzzNumber: [28],
  },
  {
    number: 64,
    nameEnglish: "At-Taghabun",
    translation: "Mutual Disillusion",
    nameArabic: "سُوْرَةُ التَّغَابُنِ",
    totalAyahs: 18,
    revelation: "Madani",
    revelationArabic: "مدنية",
    revelationOrder: 108,
    juzzNumber: [28],
  },
  {
    number: 65,
    nameEnglish: "At-Talaq",
    translation: "Divorce",
    nameArabic: "سُوْرَةُ الطَّلَاقِ",
    totalAyahs: 12,
    revelation: "Madani",
    revelationArabic: "مدنية",
    revelationOrder: 99,
    juzzNumber: [28],
  },
  {
    number: 66,
    nameEnglish: "At-Tahrim",
    translation: "The Prohibition",
    nameArabic: "سُوْرَةُ التَّحْرِيْمِ",
    totalAyahs: 12,
    revelation: "Madani",
    revelationArabic: "مدنية",
    revelationOrder: 107,
    juzzNumber: [28],
  },
  {
    number: 67,
    nameEnglish: "Al-Mulk",
    translation: "The Sovereignty",
    nameArabic: "سُوْرَةُ الْمُلْكِ",
    totalAyahs: 30,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 77,
    juzzNumber: [29],
  },
  {
    number: 68,
    nameEnglish: "Al-Qalam",
    nameArabic: "سُوْرَةُ الْقَلَمِ",
    translation: "The Pen",
    totalAyahs: 52,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 2,
    juzzNumber: [29],
  },
  {
    number: 69,
    nameEnglish: "Al-Haqqah",
    translation: "The Reality",
    nameArabic: "سُوْرَةُ الْحَآقَّةِ",
    totalAyahs: 52,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 78,
    juzzNumber: [29],
  },
  {
    number: 70,
    nameEnglish: "Al-Maarij",
    translation: "The Ascending Stairways",
    nameArabic: "سُوْرَةُ الْمَعَارِجِ",
    totalAyahs: 44,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 79,
    juzzNumber: [29],
  },
  {
    number: 71,
    nameEnglish: "Nuh",
    translation: "Noah",
    nameArabic: "سُوْرَةُ نُوْحٍ",
    totalAyahs: 28,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 71,
    juzzNumber: [29],
  },
  {
    number: 72,
    nameEnglish: "Al-Jinn",
    translation: "The Jinn",
    nameArabic: "سُوْرَةُ الْجِنِّ",
    totalAyahs: 28,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 40,
    juzzNumber: [29],
  },
  {
    number: 73,
    nameEnglish: "Al-Muzzammil",
    translation: "The Enshrouded One",
    nameArabic: "سُوْرَةُ الْمُزَّمِّلِ",
    totalAyahs: 20,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 3,
    juzzNumber: [29],
  },
  {
    number: 74,
    nameEnglish: "Al-Muddathir",
    translation: "The Cloaked One",
    nameArabic: "سُوْرَةُ الْمُدَّثِّرِ",
    totalAyahs: 56,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 4,
    juzzNumber: [29],
  },
  {
    number: 75,
    nameEnglish: "Al-Qiyamah",
    translation: "The Resurrection",
    nameArabic: "سُوْرَةُ الْقِيَامَةِ",
    totalAyahs: 40,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 31,
    juzzNumber: [29],
  },
  {
    number: 76,
    nameEnglish: "Al-Insan",
    translation: "Man",
    nameArabic: "سُوْرَةُ الدَّهْرِ",
    totalAyahs: 31,
    revelation: "Madani",
    revelationArabic: "مدنية",
    revelationOrder: 98,
    juzzNumber: [29],
  },
  {
    number: 77,
    nameEnglish: "Al-Mursalat",
    translation: "The Emissaries",
    nameArabic: "سُوْرَةُ الْمُرْسَلَاتِ",
    totalAyahs: 50,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 33,
    juzzNumber: [29],
  },
  {
    number: 78,
    nameEnglish: "An-Naba",
    translation: "The Announcement",
    nameArabic: "سُوْرَةُ النَّبَاِ",
    totalAyahs: 40,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 80,
    juzzNumber: [30],
  },
  {
    number: 79,
    nameEnglish: "An-Naziat",
    translation: "Those who drag forth",
    nameArabic: "سُوْرَةُ النَّازِعَاتِ",
    totalAyahs: 46,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 81,
    juzzNumber: [30],
  },
  {
    number: 80,
    nameEnglish: "Abasa",
    translation: "He frowned",
    nameArabic: "سُوْرَةُ عَبَسَ",
    totalAyahs: 42,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 24,
    juzzNumber: [30],
  },
  {
    number: 81,
    nameEnglish: "At-Takwir",
    translation: "The Overthrowing",
    nameArabic: "سُوْرَةُ التَّكْوِيْرِ",
    totalAyahs: 29,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 7,
    juzzNumber: [30],
  },
  {
    number: 82,
    nameEnglish: "Al-Infitar",
    translation: "The Cleaving",
    nameArabic: "سُوْرَةُ الْاِنْفِطَارِ",
    totalAyahs: 19,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 82,
    juzzNumber: [30],
  },
  {
    nameEnglish: "Al-Mutaffifin",
    number: 83,
    translation: "Defrauding",
    nameArabic: "سُوْرَةُ المُطَفِّفِيْنَ",
    totalAyahs: 36,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 86,
    juzzNumber: [30],
  },
  {
    number: 84,
    nameEnglish: "Al-Inshiqaq",
    translation: "The Splitting Open",
    nameArabic: "سُوْرَةُ الاِنْشِقَاقِ",
    totalAyahs: 25,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 83,
    juzzNumber: [30],
  },
  {
    number: 85,
    nameEnglish: "Al-Buruj",
    translation: "The Constellations",
    nameArabic: "سُوْرَةُ الْبُرُوْجِ",
    totalAyahs: 22,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 27,
    juzzNumber: [30],
  },
  {
    number: 86,
    nameEnglish: "At-Tariq",
    translation: "The Morning Star",
    nameArabic: "سُوْرَةُ الطَّارِقِ",
    totalAyahs: 17,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 36,
    juzzNumber: [30],
  },
  {
    number: 87,
    nameEnglish: "Al-Ala",
    translation: "The Most High",
    nameArabic: "سُوْرَةُ الْاَعْلٰي",
    totalAyahs: 19,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 8,
    juzzNumber: [30],
  },
  {
    number: 88,
    nameEnglish: "Al-Ghashiya",
    translation: "The Overwhelming",
    nameArabic: "سُوْرَةُ الْغَاشِيَةِ",
    totalAyahs: 26,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 68,
    juzzNumber: [30],
  },
  {
    number: 89,
    nameEnglish: "Al-Fajr",
    translation: "The Dawn",
    nameArabic: "سُوْرَةُ الْفَجْرِ",
    totalAyahs: 30,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 10,
    juzzNumber: [30],
  },
  {
    number: 90,
    nameEnglish: "Al-Balad",
    translation: "The City",
    nameArabic: "سُوْرَةُ الْبَلَدِ",
    totalAyahs: 20,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 35,
    juzzNumber: [30],
  },
  {
    number: 91,
    nameEnglish: "Ash-Shams",
    translation: "The Sun",
    nameArabic: "سُوْرَةُ الشَّمْسِ",
    totalAyahs: 15,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 26,
    juzzNumber: [30],
  },
  {
    number: 92,
    nameEnglish: "Al-Layl",
    translation: "The Night",
    nameArabic: "سُوْرَةُ الَّيْلِ",
    totalAyahs: 21,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 9,
    juzzNumber: [30],
  },
  {
    number: 93,
    nameEnglish: "Ad-Duha",
    translation: "The Morning Hours",
    nameArabic: "سُوْرَةُ الضُّحٰي",
    totalAyahs: 11,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 11,
    juzzNumber: [30],
  },
  {
    number: 94,
    nameEnglish: "Ash-Sharh",
    translation: "The Consolation",
    nameArabic: "سُوْرَةُ الشَّرْحِ",
    totalAyahs: 8,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 12,
    juzzNumber: [30],
  },
  {
    number: 95,
    nameEnglish: "At-Tin",
    translation: "The Fig",
    nameArabic: "سُوْرَةُ التِّيْنِ",
    totalAyahs: 8,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 28,
    juzzNumber: [30],
  },
  {
    number: 96,
    nameEnglish: "Al-Alaq",
    translation: "The Clot",
    nameArabic: "سُوْرَةُ الْعَلَقِ",
    totalAyahs: 19,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 1,
    juzzNumber: [30],
  },
  {
    number: 97,
    nameEnglish: "Al-Qadr",
    translation: "The Power, Fate",
    nameArabic: "سُوْرَةُ الْقَدْرِ",
    totalAyahs: 5,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 25,
    juzzNumber: [30],
  },
  {
    number: 98,
    nameEnglish: "Al-Bayyina",
    translation: "The Evidence",
    nameArabic: "سُوْرَةُ الْبَيِّنَةِ",
    totalAyahs: 8,
    revelation: "Madani",
    revelationArabic: "مدنية",
    revelationOrder: 100,
    juzzNumber: [30],
  },
  {
    number: 99,
    nameEnglish: "Az-Zalzala",
    translation: "The Earthquake",
    nameArabic: "سُوْرَةُ الزِّلْزَالِ",
    totalAyahs: 8,
    revelation: "Madani",
    revelationArabic: "مدنية",
    revelationOrder: 93,
    juzzNumber: [30],
  },
  {
    number: 100,
    nameEnglish: "Al-Adiyat",
    translation: "The Chargers",
    nameArabic: "سُوْرَةُ العٰدِيٰتِ",
    totalAyahs: 11,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 14,
    juzzNumber: [30],
  },
  {
    number: 101,
    nameEnglish: "Al-Qaria",
    translation: "The Calamity",
    nameArabic: "سُوْرَةُ الْقَارِعَةِ",
    totalAyahs: 11,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 30,
    juzzNumber: [30],
  },
  {
    number: 102,
    nameEnglish: "At-Takathur",
    translation: "Competition",
    nameArabic: "سُوْرَةُ التَّكَاثُرِ",
    totalAyahs: 8,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 16,
    juzzNumber: [30],
  },
  {
    number: 103,
    nameEnglish: "Al-Asr",
    translation: "The Declining Day, Epoch",
    nameArabic: "سُوْرَةُ الْعَصْرِ",
    totalAyahs: 3,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 13,
    juzzNumber: [30],
  },
  {
    number: 104,
    nameEnglish: "Al-Humazah",
    translation: "The Traducer",
    nameArabic: "سُوْرَةُ الْهُمَزَةِ",
    totalAyahs: 9,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 32,
    juzzNumber: [30],
  },
  {
    number: 105,
    nameEnglish: "Al-Fil",
    translation: "The Elephant",
    nameArabic: "سُوْرَةُ الْفِيْلِ",
    totalAyahs: 5,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 19,
    juzzNumber: [30],
  },
  {
    number: 106,
    nameEnglish: "Quraysh",
    translation: "Quraysh",
    nameArabic: "سُوْرَةُ قُرَيْشٍ",
    totalAyahs: 4,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 29,
    juzzNumber: [30],
  },
  {
    number: 107,
    nameEnglish: "Al-Maun",
    translation: "Almsgiving",
    nameArabic: "سُوْرَةُ الْمَاعُوْنِ",
    totalAyahs: 7,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 17,
    juzzNumber: [30],
  },
  {
    number: 108,
    nameEnglish: "Al-Kawthar",
    translation: "Abundance",
    nameArabic: "سُوْرَةُ الْكَوْثَرِ",
    totalAyahs: 3,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 15,
    juzzNumber: [30],
  },
  {
    number: 109,
    nameEnglish: "Al-Kafiroon",
    translation: "The Disbelievers",
    nameArabic: "سُوْرَةُ الْكَافِرُوْنَ",
    totalAyahs: 6,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 18,
    juzzNumber: [30],
  },
  {
    number: 110,
    nameEnglish: "An-Nasr",
    translation: "Divine Support",
    nameArabic: "سُوْرَةُ النَّصْرِ",
    totalAyahs: 3,
    revelation: "Madani",
    revelationArabic: "مدنية",
    revelationOrder: 114,
    juzzNumber: [30],
  },
  {
    number: 111,
    nameEnglish: "Al-Masad",
    translation: "The Palm Fibre",
    nameArabic: "سُوْرَةُ المَسَدِ",
    totalAyahs: 5,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 6,
    juzzNumber: [30],
  },
  {
    number: 112,
    nameEnglish: "Al-Ikhlas",
    translation: "Sincerity",
    nameArabic: "سُوْرَةُ الْاِخْلَاصِ",
    totalAyahs: 4,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 22,
    juzzNumber: [30],
  },
  {
    number: 113,
    nameEnglish: "Al-Falaq",
    translation: "The Dawn",
    nameArabic: "سُوْرَةُ الْفَلَقِ",
    totalAyahs: 5,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 20,
    juzzNumber: [30],
  },
  {
    number: 114,
    nameEnglish: "An-Nas",
    translation: "The Mankind",
    nameArabic: "سُوْرَةُ النَّاسِ",
    totalAyahs: 6,
    revelation: "Makki",
    revelationArabic: "مكية",
    revelationOrder: 21,
    juzzNumber: [30],
  },
];
export { surahs };
